
		<div>
		<div style="display: flex;justify-content: space-between;flex-direction: row-reverse;">
			<div style="display: flex">
				<div *ngIf="tu_stats">
					<div *ngIf="counter === 0 && !saveInProgress" style="display: inline-block">
						<img id="playButton" src="/assets/images/pauseplay.jpg" title="Start" width="40" height="40"
							style="cursor: pointer" (click)="editToStartTimer()" />
						00:00:00
					</div>
					<div *ngIf="counter !== 0" style="display: inline-block">
						<img id="playButton" src="/assets/images/pauseplay.jpg" title="End" width="40" height="40"
							style="cursor: pointer; margin-top: 8px" (click)="clearTimer()" />
						{{ display_time }}
					</div>
				</div>
				<div *ngIf="counter === 0" style="display: flex; margin-left: 5px">
					<div style="display: inline-block; padding-right: 5px">
						<button mat-raised-button color="primary"
							style="width: 100px; text-align: center; margin-right: 5px" (click)="userSubmit()"
							[disabled]="saveInProgress">
							Save
						</button>
					</div>
				</div>
			</div>
			<select class="form-select" (change)="updateApplicationType($event)" *ngIf="application?.Co_Appl_Required"
				style="width: 250px; margin: 0; cursor: pointer">
				<option value="Primary">Primary</option>
				<option value="Co-applicant">Co-applicant</option>
			</select>
		</div>
		<ngb-alert *ngIf="errorMessage.length !== 0" [type]="alertType" (closed)="clearErrors()">
			{{ errorMessage }}
		</ngb-alert>
		<mat-card appearance = "outlined" style="margin-top: 1em;">
			<mat-card-content>
				<div class="top-bar-grid-container">
					<div>
						<strong>Interviewer:</strong> 
						<span *ngIf="interViewerInfo && isTopBarLoaded; else loadTopBar">
							{{ interViewerInfo?.interviewer }}
							<small style="font-size: 15px">({{ interViewerInfo.duration }})</small>
						</span>
					</div>
					<div>
						<strong>Credit Utilization:</strong>
						<span *ngIf="interViewerInfo && isTopBarLoaded; else loadTopBar">
							{{ tu_stats?.credit_util }}%
						</span>
					</div>
					<div>
						<strong>TDSR:</strong> 					
						<span *ngIf="interViewerInfo && isTopBarLoaded; else loadTopBar">
							{{ application?.TDSR }}%
						</span>
					</div>
					<div>
						<strong>Credit Score:</strong> 
						<span *ngIf="interViewerInfo && isTopBarLoaded; else loadTopBar">
							{{ credit_score }}
						</span>					
					</div>
					<div>
						<strong>Collections:</strong> 					 
						<span *ngIf="tu_stats && isTopBarLoaded; else loadTopBar">
							${{ tu_stats?.collection_balance }}({{tu_stats?.no_collections}})
						</span>
					</div>
					<div>
						<strong>Trades(2-4):</strong>
						<span *ngIf="tu_stats && isTopBarLoaded; else loadTopBar">						
							${{ tu_stats?.trades_balance_2_4 }}({{tu_stats?.no_trades_2_4}})
						</span>
					</div>
					<div>
						<strong>Modified By:</strong> 					
						<span *ngIf="tu_stats && isTopBarLoaded; else loadTopBar">			
							{{ interViewerInfo?.modified_by }}
							<small style="font-size: 15px">({{ interViewerInfo?.modified_at }})</small>
						</span>
					</div>
					<div>
						<strong>LTV:</strong>  					
						<span *ngIf="tu_stats && isTopBarLoaded; else loadTopBar">	
							{{ underwritingEntry?.LTV }}%
						</span>
					</div>
					<div>
						<strong>Judgments:</strong>   					
						<span *ngIf="tu_stats && isTopBarLoaded; else loadTopBar">	
							${{ tu_stats?.legal_balance }}({{tu_stats?.no_legals}})
						</span>
					</div>
					<div>
						<strong>Trades(5-9):</strong>   					
						<span *ngIf="tu_stats && isTopBarLoaded; else loadTopBar">	 
							${{ tu_stats?.trades_balance_5_9 }}({{tu_stats?.no_trades_5_9}})
						</span>
					</div>
				</div>
			</mat-card-content>
		</mat-card>		
		<ng-template #loadTopBar>			
			<ngx-skeleton-loader count="1" appearance="line" 
			[theme]="{ 
			'height': '30px', 
			'width': '80px', 
			'display': 'inline-block', 
			'margin-left': '5px',
			'vertical-align': 'middle',
			'margin-bottom': '0'}" />
		</ng-template>	

		<mat-card appearance = "outlined" style="margin-top: 1em;">
			<mat-card-content>
				<h5>Pre-Qualifying</h5>
				<div class="content-grid">
					<mat-form-field *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
						<mat-label>Residency Status</mat-label>
						<mat-select [(ngModel)]="underwritingEntry.residency_status">
							<mat-option *ngFor="let resident of residencies" [value]="resident">
								{{ resident }}
							</mat-option>
						</mat-select>
					</mat-form-field>
					<mat-form-field *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
						<mat-label>Is this address on a native reserve?</mat-label>
						<mat-select [(ngModel)]="underwritingEntry.native_reserve">
							<mat-option value="none" selected [disabled] hidden>-None-</mat-option>
							<mat-option value="Yes">Yes</mat-option>
							<mat-option value="No">No</mat-option>
						</mat-select>
					</mat-form-field>
					<mat-form-field *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
						<mat-label>Is this a staffing agency? </mat-label>
						<mat-select [(ngModel)]="underwritingEntry.staffing_agency">
							<mat-option value="none" selected [disabled] hidden>-None-</mat-option>
							<mat-option value="Yes">Yes</mat-option>
							<mat-option value="No">No</mat-option>
						</mat-select>
					</mat-form-field>
					<mat-form-field *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
						<mat-label>Are you currently in a CP, CC, active BK or in progress? </mat-label>						
						<mat-select [(ngModel)]="underwritingEntry.insolvency_status">
							<mat-option *ngFor="let insolvency of insolvencies" [value]="insolvency">
								{{ insolvency }}
							</mat-option>
						</mat-select>
					</mat-form-field>	
					<mat-form-field *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
						<mat-label>Any active judgements?</mat-label>
						<mat-select [(ngModel)]="underwritingEntry.active_judgements">
							<mat-option value="none" selected [disabled] hidden>-None-</mat-option>
							<mat-option value="Yes">Yes</mat-option>
							<mat-option value="No">No</mat-option>
						</mat-select>
					</mat-form-field>		
				</div>
				<h5>Employment Information</h5>
				<div *ngIf="applicantType === 'Primary'">
					<div class="content-grid">
						<mat-form-field *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
							<mat-label>Employer</mat-label>
							<input type="text" matInput [(ngModel)]="this.underwritingEntry.Employer"/>
						</mat-form-field>

						<mat-form-field *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
							<mat-label>Industry</mat-label>
							<mat-select [(ngModel)]="underwritingEntry.Industry" placeholder="Select Industry">
								<!-- Search Input -->
    							<mat-option>
									<ngx-mat-select-search 
										ngModel 
										(ngModelChange)="filterOptions_industry($event)"
										placeholderLabel="Search..."
										noEntriesFoundLabel="No matching results">
									</ngx-mat-select-search>
								</mat-option>
								<!-- Filtered Options -->
								<mat-option *ngFor="let option of filteredOptions_industry" [value]="option.display_value">
								{{ option.display_value }}
								</mat-option>
							</mat-select>
						</mat-form-field>
					
						<mat-form-field *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
							<mat-label>Employment Status</mat-label>
							<mat-select [(ngModel)]="this.underwritingEntry.Employment_Status1">
								<mat-option *ngFor="let i of emp_type_look_up" [value]="i.display_value">
									{{ i.display_value }}
								</mat-option>
							</mat-select>
						</mat-form-field>

						<mat-form-field *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
							<mat-label>Occupation</mat-label>
							<mat-select [(ngModel)]="underwritingEntry.Occupation" placeholder="Select Occupation">
								<!-- Search Input -->
    							<mat-option>
									<ngx-mat-select-search 
										ngModel 
										(ngModelChange)="filterOptions_occupation($event)"
										placeholderLabel="Search..."
										noEntriesFoundLabel="No matching results">
									</ngx-mat-select-search>
								</mat-option>
								<!-- Filtered Options -->
								<mat-option *ngFor="let option of filteredOptions_occupation" [value]="option.display_value">
								{{ option.display_value }}
								</mat-option>
							</mat-select>
						</mat-form-field>
					
						<mat-form-field *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
							<mat-label>Work Phone</mat-label>
							<input type="text" [(ngModel)]="this.underwritingEntry.Work_Phone" matInput/>
						</mat-form-field>

						<mat-form-field *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
							<mat-label>Payment Frequency</mat-label>
							<mat-select [(ngModel)]="this.underwritingEntry.Pay_Frequency2">
								<mat-option value="none" selected [disabled] hidden>-None-</mat-option>
								<mat-option *ngFor="let i of salary_frequency_look_up" [value]="i.display_value">
									{{ i.display_value }}
								</mat-option>
							</mat-select>
						</mat-form-field>

						<mat-form-field *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
							<mat-label>Work Extension</mat-label>
							<input type="text" [(ngModel)]="this.underwritingEntry.Work_Extension" matInput/>
						</mat-form-field>

						<mat-form-field *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
							<mat-label>Last Pay Date</mat-label>
							<input [(ngModel)]="this.underwritingEntry.Last_Pay_Date" matInput [matDatepicker]="pickerLast"/>
							<mat-datepicker-toggle matIconSuffix [for]="pickerLast"></mat-datepicker-toggle>
							<mat-datepicker #pickerLast></mat-datepicker>
						</mat-form-field>

						<mat-form-field *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
							<mat-label>Length of Employment (Month)</mat-label>
							<input type="text" [(ngModel)]="this.underwritingEntry.Length_of_Employment" matInput/>
						</mat-form-field>

						<mat-form-field *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
							<mat-label>Next Pay Date</mat-label>
							<input [(ngModel)]="this.underwritingEntry.Next_Pay_Date" matInput [matDatepicker]="pickerNext"/>
							<mat-datepicker-toggle matIconSuffix [for]="pickerNext"></mat-datepicker-toggle>
							<mat-datepicker #pickerNext></mat-datepicker>
						</mat-form-field>

						<mat-form-field *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
							<mat-label>Position</mat-label>
							<input type="text" [(ngModel)]="this.underwritingEntry.Position" matInput/>
						</mat-form-field>

						<mat-form-field *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
							<mat-label>Income (net paycheque income)</mat-label>
							<input type="text" [(ngModel)]="this.underwritingEntry.Income_net_paycheque_income" matInput/>
						</mat-form-field>

						<mat-form-field *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
							<mat-label>Supervisor Name</mat-label>
							<input type="text" type="text" [(ngModel)]="this.underwritingEntry.Supervisor_Name" matInput/>
						</mat-form-field>

						<mat-form-field *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
							<mat-label>Supervisor Phone Number</mat-label>
							<input type="text" [(ngModel)]="this.underwritingEntry.Supervisor_Phone_Number" matInput />
						</mat-form-field>

						<mat-form-field *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
							<mat-label>Income Amount (Household Income)</mat-label>
							<input type="text" [(ngModel)]="this.underwritingEntry.Income_Amount_Household_Income" matInput/>
						</mat-form-field>

						<mat-form-field *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
							<mat-label>Employer Name (Household Income)</mat-label>
							<input type="text" [(ngModel)]="this.underwritingEntry.Employer_Name_Household_Income" matInput/>
						</mat-form-field>

						<mat-form-field *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
							<mat-label>Pay Frequency (Household Income)</mat-label>
							<mat-select [(ngModel)]="this.underwritingEntry.Pay_Frequency_Household_Income">
								<mat-option value="none" selected [disabled] hidden>-None-</mat-option>
								<mat-option *ngFor="let i of salary_frequency_household_look_up" [value]="i.display_value">
									{{ i.display_value }}
								</mat-option>
							</mat-select>
						</mat-form-field>

						<mat-form-field *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
							<mat-label>Additional Employment Details</mat-label>
							<input type="text" [(ngModel)]="this.underwritingEntry.Additional_Employment" matInput/>
						</mat-form-field>

						<mat-form-field *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
							<mat-label>Previous Employment Section?</mat-label>
							<input type="text" [value]="underwritingEntry.Previous_Employment === true ? 'Yes' : 'No'" matInput readonly/>
						</mat-form-field>					
					</div>				
				</div>
				<div *ngIf="applicantType === 'Primary' && underwritingEntry.Previous_Employment === true">
					<h5>Previous Employment Information</h5>
					<div class="content-grid">
						<mat-form-field *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
							<mat-label>Previous Empolyment Type</mat-label>
							<input type="text" [value]="underwritingEntry.Previous_Employment_Type" matInput readonly/>
						</mat-form-field>
						<mat-form-field *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
							<mat-label>Previous Position</mat-label>
							<input type="text" [value]="underwritingEntry.Previous_Position" matInput readonly/>
						</mat-form-field>	
						<mat-form-field *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
							<mat-label>Previous Employer</mat-label>
							<input type="text" [value]="underwritingEntry.Previous_Employer" matInput readonly/>
						</mat-form-field>	
						<mat-form-field *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
							<mat-label>Previous Length of Employment (Month)</mat-label>
							<input type="text" [value]="underwritingEntry.Previous_Length_of_Employment" matInput readonly/>
						</mat-form-field>	
						<mat-form-field *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
							<mat-label>Previous Supervisor Name</mat-label>
							<input type="text" [value]="underwritingEntry.Previous_Supervisor_Name" matInput readonly/>
						</mat-form-field>	
						<mat-form-field *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
							<mat-label>Previous Supervisor Phone Number</mat-label>
							<input type="text" [value]="underwritingEntry.Previous_Supervisor_Phone_number" matInput readonly/>
						</mat-form-field>	
						<mat-form-field *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
							<mat-label>Previous Income (net paycheque income)</mat-label>
							<input type="text" [value]="underwritingEntry.Previous_Income_net_paycheque_income" matInput readonly/>
						</mat-form-field>	
						<mat-form-field *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
							<mat-label>Previous Pay Frequency</mat-label>
							<input type="text" [value]="underwritingEntry.Previous_Pay_Frequency" matInput readonly/>
						</mat-form-field>	
						<mat-form-field *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
							<mat-label>Previous Payment Method</mat-label>
							<input type="text" [value]="underwritingEntry.Previous_Payment_Method" matInput readonly/>
						</mat-form-field>								
					</div>
				</div>
				<div *ngIf="applicantType === 'Co-applicant'">
					<div class="content-grid">
						<mat-form-field *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
							<mat-label>Employment Type</mat-label>
							<mat-select [(ngModel)]="underwritingEntry.Co_Applicant_Status">
								<mat-option *ngFor="let i of co_app_emp_type_look_up" [value]="i.display_value">
									{{ i.display_value }}
								</mat-option>
							</mat-select>
						</mat-form-field>
						<mat-form-field *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
							<mat-label>Employer</mat-label>
							<input type="text" matInput [(ngModel)]="underwritingEntry.Co_Applicant_Employer"/>
						</mat-form-field>
						<mat-form-field *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
							<mat-label>Supervisor Name</mat-label>
							<input type="text" matInput [(ngModel)]="underwritingEntry.Co_Applicant_Supervisor_Name"/>
						</mat-form-field>
						<mat-form-field *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
							<mat-label>Annual Income</mat-label>
							<input type="text" matInput [(ngModel)]="underwritingEntry.Sec_Annual_Income"/>
						</mat-form-field>
						<mat-form-field *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
							<mat-label>Payment Method</mat-label>
							<mat-select [(ngModel)]="underwritingEntry.Co_Applicant_Payment_Method">
								<mat-option value="none" selected [disabled] hidden>-None-</mat-option>
								<mat-option *ngFor="let i of pay_method_look_up" [value]="i.display_value">
									{{ i.display_value }}
								</mat-option>
							</mat-select>
						</mat-form-field>
						<mat-form-field *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
							<mat-label>Industry</mat-label>
							<mat-select [(ngModel)]="underwritingEntry.Co_Applicant_Industry" placeholder="Select Industry">
								<!-- Search Input -->
    							<mat-option>
									<ngx-mat-select-search 
										ngModel 
										(ngModelChange)="filterOptions_coapp_industry($event)"
										placeholderLabel="Search..."
										noEntriesFoundLabel="No matching results">
									</ngx-mat-select-search>
								</mat-option>
								<!-- Filtered Options -->
								<mat-option *ngFor="let option of filteredOptions_coapp_industry" [value]="option.display_value">
								{{ option.display_value }}
								</mat-option>
							</mat-select>
						</mat-form-field>
						<mat-form-field *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
							<mat-label>Occupation</mat-label>
							<mat-select [(ngModel)]="underwritingEntry.Co_Applicant_Occupation" placeholder="Select Occupation">
								<!-- Search Input -->								
    							<mat-option>
									<ngx-mat-select-search 
										ngModel 
										(ngModelChange)="filterOptions_coapp_occupation($event)"
										placeholderLabel="Search..."
										noEntriesFoundLabel="No matching results">
									</ngx-mat-select-search>
								</mat-option>
								<!-- Filtered Options -->
								<mat-option *ngFor="let option of filteredOptions_coapp_occupation" [value]="option.display_value">
								{{ option.display_value }}
								</mat-option>
							</mat-select>
						</mat-form-field>
						<mat-form-field *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
							<mat-label>Position</mat-label>
							<input type="text" matInput [(ngModel)]="underwritingEntry.Secondary_Position"/>
						</mat-form-field>
						<mat-form-field *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
							<mat-label>Length of Employment (Month)</mat-label>
							<input type="text" matInput [(ngModel)]="underwritingEntry.Secondary_Years_Worked"/>
						</mat-form-field>
						<mat-form-field *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
							<mat-label>Supervisor Phone Number</mat-label>
							<input type="text" matInput [(ngModel)]="underwritingEntry.Co_Applicant_Supervisor_Phone_Number"/>
						</mat-form-field>
						<mat-form-field *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
							<mat-label>Work Number</mat-label>
							<input type="text" matInput [(ngModel)]="underwritingEntry.Secondary_Work_Number"/>
						</mat-form-field>
						<mat-form-field *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
							<mat-label>Pay Frequency (Household Income)</mat-label>
							<mat-select [(ngModel)]="underwritingEntry.Co_Applicant_Pay_Frequency">
								<mat-option value="none" selected [disabled] hidden>-None-</mat-option>
								<mat-option *ngFor="let i of salary_frequency_look_up" [value]="i.display_value">
									{{ i.display_value }}
								</mat-option>
							</mat-select>
						</mat-form-field>
					</div>
				</div>
				<h5>Statements/Budget</h5>
				<div class="content-grid">
					<mat-form-field *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
						<mat-label>Review Payday usage</mat-label>
						<mat-select [(ngModel)]="underwritingEntry.Review_any_payday_loan_usage">
							<mat-option value="none" selected [disabled] hidden>-None-</mat-option>
							<mat-option value="Yes">Yes</mat-option>
							<mat-option value="No">No</mat-option>
						</mat-select>
					</mat-form-field>	

					<mat-form-field *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
						<mat-label>Payday Comments</mat-label>
						<textarea rows="1" matInput [(ngModel)]="underwritingEntry.Payday_Loans_Comments"></textarea>
					</mat-form-field>
					<div></div>
					<mat-form-field *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
						<mat-label>Overdraft Limit?</mat-label>
						<mat-select [(ngModel)]="underwritingEntry.Overdraft_Limit_Question" 
						(selectionChange)="clearField($event.value, 'underwritingEntry', 'Overdraft_Limit', 'number')">
							<mat-option value="none" selected [disabled] hidden>-None-</mat-option>
							<mat-option value="Yes">Yes</mat-option>
							<mat-option value="No">No</mat-option>
						</mat-select>
					</mat-form-field>	

					<mat-form-field *ngIf="underwritingEntry.Overdraft_Limit_Question === 'Yes'">
						<mat-label>Overdraft Limit</mat-label>
						<input type="number" matInput [(ngModel)]="underwritingEntry.Overdraft_Limit" >
					</mat-form-field>

					<mat-form-field *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
						<mat-label>Is this a join Account?</mat-label>
						<mat-select [(ngModel)]="underwritingEntry.Is_this_a_joint_Account"
						(selectionChange)="clearField($event.value, 'underwritingEntry', 'Is_this_a_joint_Account_Note', 'string')">
							<mat-option value="none" selected [disabled] hidden>-None-</mat-option>
							<mat-option value="Yes">Yes</mat-option>
							<mat-option value="No">No</mat-option>
						</mat-select>
					</mat-form-field>	

					<mat-form-field *ngIf="this.underwritingEntry.Is_this_a_joint_Account === 'Yes'">
						<mat-label>Explanation</mat-label>
						<textarea rows="1" matInput [(ngModel)]="underwritingEntry.Is_this_a_joint_Account_Note"></textarea>
					</mat-form-field>	

					<mat-form-field *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
						<mat-label>Reason for falling behind</mat-label>
						<textarea rows="1" matInput [(ngModel)]="underwritingEntry.Reason_for_falling_behind"></textarea>
					</mat-form-field>
				</div>
				<h5>Taxes/Dependents</h5>
				<div class="content-grid">
					<mat-form-field *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
						<mat-label>When was the last time you filed taxes?</mat-label>
						<mat-select [(ngModel)]="underwritingEntry.When_was_the_last_time_you_filed_taxes">
							<mat-option value="none" selected [disabled] hidden>-None-</mat-option>
							<mat-option value="Up to Date">Up to Date</mat-option>
							<mat-option value="Behind">Behind</mat-option>
							<mat-option value="Never">Never</mat-option>
						</mat-select>
					</mat-form-field>		

					<mat-form-field *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
						<mat-label>How much do owe to Revenue Canada?</mat-label>
						<input type="number" matInput [(ngModel)]="underwritingEntry.How_much_do_you_owe_Revenue_Canada"/>
					</mat-form-field>

					<mat-form-field *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
						<mat-label>Have you setup an arrangement with the CRA?</mat-label>
						<mat-select [(ngModel)]="underwritingEntry.Have_you_setup_an_arrangement_with_the_CRA">
							<mat-option value="none" selected [disabled] hidden>-None-</mat-option>
							<mat-option value="Yes">Yes</mat-option>
							<mat-option value="No">No</mat-option>
						</mat-select>
					</mat-form-field>	

					<mat-form-field *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
						<mat-label>Do you live with anyone else?</mat-label>
						<mat-select [(ngModel)]="underwritingEntry.Do_you_live_with_anyone_else">
							<mat-option value="none" selected [disabled] hidden>-None-</mat-option>
							<mat-option value="Yes">Yes</mat-option>
							<mat-option value="No">No</mat-option>
						</mat-select>
					</mat-form-field>	

					<mat-form-field *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
						<mat-label>Number of Dependents</mat-label>
						<mat-select [(ngModel)]="underwritingEntry.Dependents">
							<mat-option value="none" selected [disabled] hidden>-None-</mat-option>
							<mat-option value="0">0</mat-option>
							<mat-option value="1">1</mat-option>
							<mat-option value="2">2</mat-option>
							<mat-option value="3">3</mat-option>
							<mat-option value="4">4</mat-option>
							<mat-option value="5">5</mat-option>
							<mat-option value="6">6</mat-option>
							<mat-option value="7">7</mat-option>
							<mat-option value="8">8</mat-option>
							<mat-option value="9">9</mat-option>
							<mat-option value="10">10</mat-option>
							<mat-option value="10+">10+</mat-option>
						</mat-select>
					</mat-form-field>	
				</div>

				<h5>Homeowner Questions</h5>
				<div class="content-grid" style="margin-bottom: 1em;">				
					<mat-form-field *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
						<mat-label>Homeowner?</mat-label>
						<mat-select [(ngModel)]="underwritingEntry.Are_you_a_homeowner" 
						(selectionChange)="clearField($event.value, 'underwritingEntry', 'homeowner', 'number')">
							<mat-option value="none" selected [disabled] hidden>-None-</mat-option>
							<mat-option value="Yes">Yes</mat-option>
							<mat-option value="No">No</mat-option>
						</mat-select>
					</mat-form-field>		
				</div>
				<div class="content-grid" *ngIf="underwritingEntry.Are_you_a_homeowner === 'Yes'">
					<mat-form-field *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
						<mat-label>Property Tax Owing?</mat-label>
						<input rows="1" type="text" matInput [(ngModel)]="underwritingEntry.Do_you_owe_any_property_tax_Howe_owners_only">
					</mat-form-field>
					<mat-form-field *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
						<mat-label>Mortgage on property?</mat-label>
						<mat-select [(ngModel)]="underwritingEntry.Is_there_a_mortgage_on_the_property">
							<mat-option value="none" selected [disabled] hidden>-None-</mat-option>
							<mat-option value="Yes">Yes</mat-option>
							<mat-option value="No">No</mat-option>
						</mat-select>
					</mat-form-field>
					<mat-form-field *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
						<mat-label>Mortage Holder(s)?</mat-label>
						<input type="text" matInput [(ngModel)]="underwritingEntry.Who_is_your_mortgage_with"/>
					</mat-form-field>
					<mat-form-field *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
						<mat-label>Purview Amount</mat-label>
						<input type="number" matInput [(ngModel)]="underwritingEntry.Purview_Value" (click)="calculateLTV()"/>
					</mat-form-field>
					<mat-form-field *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
						<mat-label>Property Amount?</mat-label>
						<input type="number" matInput [(ngModel)]="underwritingEntry.What_is_current_value_of_the_property" (click)="calculateLTV()"/>
					</mat-form-field>
					<mat-form-field *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
						<mat-label>Mortgage Balance?</mat-label>
						<input type="number" matInput [(ngModel)]="underwritingEntry.What_is_the_balance_of_your_mortgage" (click)="calculateLTV()"/>
					</mat-form-field>
					<mat-form-field *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
						<mat-label>Mortgage Interest Rate?</mat-label>
						<input type="number" matInput [(ngModel)]="underwritingEntry.What_interest_rate_on_your_mortgage" (click)="calculateLTV()"/>
					</mat-form-field>					

				</div>
				<h5>Expenses</h5>
				<div class="content-grid">
					<mat-form-field *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
						<mat-label>Do you receive any child tax?</mat-label>
						<mat-select [(ngModel)]="underwritingEntry.child_tax"
						(selectionChange)="clearField($event.value, 'underwritingEntry', 'child_tax_amount', 'number')">
							<mat-option value="none" selected [disabled] hidden>-None-</mat-option>
							<mat-option value="Yes">Yes</mat-option>
							<mat-option value="No">No</mat-option>
						</mat-select>
					</mat-form-field>	
					<mat-form-field *ngIf="underwritingEntry.child_tax === 'Yes'">
						<mat-label>Child tax amount</mat-label>
						<input type="number" matInput [(ngModel)]="underwritingEntry.child_tax_amount"/>
					</mat-form-field>
				</div>				
				<div class="content-grid">
					<mat-form-field *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
						<mat-label>Do you receive or pay any child support?</mat-label>
						<mat-select [(ngModel)]="underwritingEntry.child_support"
						(selectionChange)="clearField($event.value, 'underwritingEntry', 'child_support_amount', 'number')">
							<mat-option value="none" selected [disabled] hidden>-None-</mat-option>
							<mat-option value="Yes">Yes</mat-option>
							<mat-option value="No">No</mat-option>
						</mat-select>
					</mat-form-field>	
					<mat-form-field *ngIf="underwritingEntry.child_support === 'Yes'">
						<mat-label>Child support amount</mat-label>
						<input type="number" matInput [(ngModel)]="underwritingEntry.child_support_amount"/>
					</mat-form-field>
				</div>
				<div style="width: 80%;">
					<div class="table-responsive" [formGroup]="userForm">
						<div class="form-group" formArrayName="ADDITIONAL_EXPENSES">
							<table class="flat-table mat-elevation-z0">
								<thead class="table-light">
									<tr>
										<th class="expenseCloseWidth" style="background-color: white;"></th>
										<th scope="col" style="background-color: white;">Type</th>
										<th scope="col" style="background-color: white;">Creditor Name</th>
										<th scope="col" style="background-color: white;">Amount (CA$)</th>
										<th scope="col" style="background-color: white;">Liability</th>
									</tr>
								</thead>
								<tbody>
									<tr *ngFor="
											let control of userForm.controls.ADDITIONAL_EXPENSES[
												'controls'
											];
											let i = index
										" [formGroupName]="i">
										<td class="expenseCloseWidth">
											<button class="btn-close" (click)="removeExpenses(i)" *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent"></button>
										</td>
										<td>
											<mat-form-field *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
												<mat-select formControlName="Type" >
													<mat-option *ngFor="let item of Expense_Types" [value]="item.expenses_type">
														{{ item.expenses_type }}</mat-option>
												</mat-select>
											</mat-form-field>
										</td>
										<td>
											<mat-form-field *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
												<input type="text" matInput formControlName="Name1" placeholder="Creditor Name"/>
											</mat-form-field>
										</td>
										<td>
											<mat-form-field *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
												<input type="number" matInput formControlName="Amount" placeholder="Amount" (click)="addExpenses()"/>
											</mat-form-field>
										</td>
										<td>
											<mat-form-field *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
												<mat-select formControlName="liabilities" >
													<mat-option *ngFor="let liability of liabilities"  [value]="liability">
														{{ liability }}</mat-option>
												</mat-select>
											</mat-form-field>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>					
					<button mat-stroked-button color="primary" (click)="addExpense()" style="margin-top: 10px">
						+ Add Expenses
					</button>									
					<div class="content-grid">
						<mat-form-field *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
							<mat-label>Do you have any other loans or bills that you are responsible for?</mat-label>
							<mat-select [(ngModel)]="underwritingEntry.other_loans_bills"
						(selectionChange)="clearField($event.value, 'underwritingEntry', 'other_loans_bills_amount', 'string')">
								<mat-option value="none" selected [disabled] hidden>-None-</mat-option>
								<mat-option value="Yes">Yes</mat-option>
								<mat-option value="No">No</mat-option>
							</mat-select>
						</mat-form-field>	
						<mat-form-field *ngIf="underwritingEntry.other_loans_bills === 'Yes'">
							<mat-label>Other loans or bills details</mat-label>
							<textarea rows="1" matInput [(ngModel)]="underwritingEntry.other_loans_bills_amount"></textarea>
						</mat-form-field>
					</div>
					<div class="total-expenses-container">
						<label>
							Total Monthly Income (CA$)
						</label>
						<mat-form-field style="width: 100%" *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
							<input type="number" matInput [(ngModel)]="n_total_monthly_income" (click)="addExpenses()"/>
						</mat-form-field>
						<label>
							Total Additional Expenses (CA$)
						</label>
						<mat-form-field style="width: 100%" *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
							<input type="number" matInput [(ngModel)]="n_total_expenses"/>
						</mat-form-field>
						<label>
							TDSR(%)
						</label>
						<mat-form-field style="width: 100%" *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
							<input type="number" matInput [(ngModel)]="n_tdsr"/>
						</mat-form-field>
						<label>
							Current Loan Amount Payments (Monthly)(CA$)
						</label>
						<mat-form-field style="width: 100%" *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
							<input type="number" matInput [(ngModel)]="n_current_loan_amount_payments" (click)="calculateExpenses()"/>
						</mat-form-field>
					</div>
				</div>
				<h5>Banking</h5>
				<div class="content-grid" *ngIf="applicantType === 'Primary'">
					<mat-form-field style="width: 100%" *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
						<mat-label>Institution Name</mat-label>
						<input type="text" matInput [(ngModel)]="underwritingEntry.Financial_Institution_Name"/>
					</mat-form-field>
					<mat-form-field style="width: 100%" *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
						<mat-label>Institution Number</mat-label>
						<input type="text" matInput [(ngModel)]="underwritingEntry.Financial_Institution_Number" 
						(click)="click_bankingValidationPrimary_InsNumber()"/>
					</mat-form-field>
					<mat-form-field style="width: 100%" *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
						<mat-label>Bank Account Number</mat-label>
						<input type="text" matInput [(ngModel)]="underwritingEntry.Bank_Account_Number"/>
					</mat-form-field>
					<mat-form-field style="width: 100%" *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
						<mat-label>Branch Transit Number</mat-label>
						<input type="text" matInput [(ngModel)]="underwritingEntry.Bank_Transit_No" (keydown)="numberOnly($event)"/>
					</mat-form-field>
					<mat-form-field style="width: 100%" *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
						<mat-label>Branch Address</mat-label>
						<input type="text" matInput [(ngModel)]="underwritingEntry.Branch_Address"/>
					</mat-form-field>
					<mat-form-field *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
						<mat-label>Other Bank Account</mat-label>
						<mat-select [(ngModel)]="underwritingEntry.Other_Bank_Account" >
							<mat-option value="none" selected [disabled] hidden>-None-</mat-option>
							<mat-option value="Yes">Yes</mat-option>
							<mat-option value="No">No</mat-option>
						</mat-select>
					</mat-form-field>
				</div>
				<div class="content-grid" *ngIf="applicantType === 'Co-applicant'">
					<mat-form-field style="width: 100%" *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
						<mat-label>Institution Name</mat-label>
						<input type="text" matInput [(ngModel)]="underwritingEntry.Co_Applicant_Financial_Institution_Name" />
					</mat-form-field>
					<mat-form-field style="width: 100%" *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
						<mat-label>Institution Number</mat-label>
						<input type="text" matInput [(ngModel)]="underwritingEntry.Co_ApplicantFinancial_Institution_Number1" 
						(click)="click_bankingValidationCo_Applicant_InsNumber()" >
					</mat-form-field>
					<mat-form-field style="width: 100%" *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
						<mat-label>Bank Account Number</mat-label>
						<input type="number" matInput [(ngModel)]="underwritingEntry.Co_Applicant_Bank_Account"/>
					</mat-form-field>
					<mat-form-field style="width: 100%" *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
						<mat-label>Branch Transit Number</mat-label>
						<input type="number" matInput [(ngModel)]="underwritingEntry.Co_Applicant_Bank_Transit_No"/>
					</mat-form-field>
					<mat-form-field style="width: 100%" *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
						<mat-label>Branch Address</mat-label>
						<input type="text" matInput [(ngModel)]="underwritingEntry.Co_Applicant_Branch_Address"/>
					</mat-form-field>
					<mat-form-field *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
						<mat-label>Other Bank Account</mat-label>
						<mat-select [(ngModel)]="underwritingEntry.Other_Bank_Account" >
							<mat-option value="none" selected [disabled] hidden>-None-</mat-option>
							<mat-option value="Yes">Yes</mat-option>
							<mat-option value="No">No</mat-option>
						</mat-select>
					</mat-form-field>
				</div>
				<h5>Approval</h5>
				<div class="content-grid" >
					<mat-form-field style="width: 100%" *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
						<mat-label>Loan Amount</mat-label>
						<input type="number" matInput [(ngModel)]="underwritingEntry.Approved_Amount"/>
					</mat-form-field>
					<mat-form-field style="width: 100%" *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
						<mat-label>First Payment Date</mat-label>
						<input type="number" matInput [(ngModel)]="underwritingEntry.Date_Ordered" readonly/>
					</mat-form-field>
					<mat-form-field *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
						<mat-label>Payment Frequency</mat-label>
						<mat-select [(ngModel)]="underwritingEntry.Opportunity_Status" >						
							<mat-option value="none" selected [disabled] hidden>-None-</mat-option>
							<mat-option value="Monthly">Monthly</mat-option>
							<mat-option value="Semi-Monthly">Semi-Monthly</mat-option>
							<mat-option value="Bi-Weekly">Bi-Weekly</mat-option>
							<mat-option value="Weekly">Weekly</mat-option>
							<mat-option value="15th and EOM">15th and EOM</mat-option>
							<mat-option value="1st and 15th">1st and 15th</mat-option>
						</mat-select>
					</mat-form-field>				
					<mat-form-field style="width: 100%" *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
						<mat-label>Term in Years</mat-label>
						<input type="number" matInput [(ngModel)]="underwritingEntry.Term_of_Loan_Years" readonly/>
					</mat-form-field>
					<mat-form-field *ngIf="underwritingEntry && isMainContentLoaded; else loadedMainContent">
						<mat-label>UW Tier</mat-label>
						<mat-select [(ngModel)]="underwritingEntry.UW_Tier" >						
							<mat-option value="none" selected [disabled] hidden>-None-</mat-option>
							<mat-option value="0">0</mat-option>
							<mat-option value="1">1</mat-option>
							<mat-option value="2">2</mat-option>
							<mat-option value="3">3</mat-option>
							<mat-option value="4">4</mat-option>
						</mat-select>
					</mat-form-field>
				</div>
			</mat-card-content>
		</mat-card>
		<ng-template #loadedMainContent>
			<ngx-skeleton-loader count="1" appearance="line" 
				[theme]="{ 
				'height': '30px', 
				'width': '250px', 
				'display': 'inline-block', 
				'margin-left': '5px',
				'vertical-align': 'middle',
				'margin-bottom': '0'}" />	
		</ng-template>
	</div>
